import { useDispatch } from "react-redux";
import {
  useCreateLocationMutation,
  useDeleteLocationMutation,
  useUpdateLocationMutation,
} from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useDeleteLocationApi = () => {
  const dispatch = useDispatch();
  const [handleDelete] = useDeleteLocationMutation();

  const send = (body) => {
    dispatch(setLoader(true));
    handleDelete(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        if (res?.message === "You can not delete the main location") {
          showToast(res?.message ?? "Error", "error");
        } else {
          showToast(res?.message ?? "Success", "success");
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useDeleteLocationApi;
